import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IDialog } from '../shared/models/dialog.model';


@Injectable()
export class DialogService {
  public dialog = new Subject<IDialog>();
}
